import type { QueryClient } from "@tanstack/react-query";
import { createResourceStorageKeys } from "src/framework/createResourceStorageKeys.ts";
import { memoryStorageDriver } from "src/storage/memoryStorage.driver.ts";
import {
  getResourceFormSavedScrollPositionKey,
  savedScrollPositions,
} from "src/system/savedScrollPositions.ts";
import { createModuleQueries } from "src/framework/createModuleQueries.ts";

export const clearCreateResourceFormState = ({
  resource,
  queryClient,
}: {
  resource: string;
  queryClient: QueryClient;
}) => {
  const storageKeys = createResourceStorageKeys({
    resource,
  });
  const storageKey = storageKeys.form({ type: "create" });
  memoryStorageDriver.remove(storageKey);
  delete savedScrollPositions[
    getResourceFormSavedScrollPositionKey({
      resource,
      action: "create",
    })
  ];
  const queryKeys = createModuleQueries();
  queryClient.removeQueries({
    queryKey: queryKeys.createFormData({
      resource,
    }),
  });
};
